import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { boundaryCRUD } from "../../actions/boundary"
import { buildingCRUD } from "../../actions/building";

export const SideContent = (props) => {

  const {
    value,
    setValue,
    category,
    setCategory,
    setListValue,
    setTypeData,
    boundaryFilter,
    setBoundaryFilter,
  } = props

  const navigate = useNavigate();

  const listInnerRef = useRef();

  const [listLoading, setListLoading] = useState(false)
  const [dataList, setDataList] = useState([])
  const [dataValue, setDatValue] = useState(null)
  const [serchValue, setSearchValue] = useState('')
  const [zOffset, setZOffset] = useState(0)
  const [bOffset, setBOffset] = useState(0)
  const [noData, setNoData] = useState(false)
  const [dataCategory, setDataCategory] = useState('')

  const [isActive, setIsActive] = useState(null);

  // Cascading filter state
  const [islands, setIslands] = useState([])
  const [regions, setRegions] = useState([])
  const [districts, setDistricts] = useState([])
  const [shehias, setShehias] = useState([])
  const [zones, setZones] = useState([])

  const [selectedIsland, setSelectedIsland] = useState('')
  const [selectedRegion, setSelectedRegion] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')
  const [selectedShehia, setSelectedShehia] = useState('')
  const [selectedZone, setSelectedZone] = useState('')

  // Load islands on mount
  useEffect(() => {
    boundaryCRUD.loadAllIslands().then((resp) => {
      setIslands(resp.data)
    }).catch(() => {})
  }, [])

  // Load regions when island selected
  useEffect(() => {
    if (selectedIsland) {
      boundaryCRUD.loadBoundaryByParent(selectedIsland).then((resp) => {
        setRegions(resp.data)
      }).catch(() => {})
    } else {
      setRegions([])
    }
    setSelectedRegion('')
    setSelectedDistrict('')
    setSelectedShehia('')
    setSelectedZone('')
    setDistricts([])
    setShehias([])
    setZones([])
  }, [selectedIsland])

  // Load districts when region selected
  useEffect(() => {
    if (selectedRegion) {
      boundaryCRUD.loadBoundaryByParent(selectedRegion).then((resp) => {
        setDistricts(resp.data)
      }).catch(() => {})
    } else {
      setDistricts([])
    }
    setSelectedDistrict('')
    setSelectedShehia('')
    setSelectedZone('')
    setShehias([])
    setZones([])
  }, [selectedRegion])

  // Load shehias when district selected
  useEffect(() => {
    if (selectedDistrict) {
      boundaryCRUD.loadBoundaryByParent(selectedDistrict).then((resp) => {
        setShehias(resp.data)
      }).catch(() => {})
    } else {
      setShehias([])
    }
    setSelectedShehia('')
    setSelectedZone('')
    setZones([])
  }, [selectedDistrict])

  // Load zones when shehia selected
  useEffect(() => {
    if (selectedShehia) {
      boundaryCRUD.loadBoundaryByParent(selectedShehia).then((resp) => {
        setZones(resp.data)
      }).catch(() => {})
    } else {
      setZones([])
    }
    setSelectedZone('')
  }, [selectedShehia])

  // Update boundaryFilter with the most specific selection
  useEffect(() => {
    if (setBoundaryFilter) {
      const filterId = selectedZone || selectedShehia || selectedDistrict || selectedRegion || selectedIsland || null;
      setBoundaryFilter(filterId)
    }
  }, [selectedIsland, selectedRegion, selectedDistrict, selectedShehia, selectedZone])


  const loadBoundaryLayer = () => {
    setListLoading(true)
    setTimeout(() => {
      boundaryCRUD.loadBoundary(15, zOffset, dataValue, serchValue).then((resp) => {
          const newList = dataList.concat(resp.data.results);
          setDataList(newList)
          setZOffset(zOffset + 15)
          if(resp.data.results.length === 0){
            setNoData(true)
          } else {
            setNoData(false)
          }
        }).catch((err) => {
          console.log(err);
        }).finally(() => {
          setListLoading(false)
        })
    }, 500)

  }

  const loadBuildingLayer = () => {
    setListLoading(true)
    setTimeout(() => {
      buildingCRUD.loadBuilding(15, bOffset, serchValue).then((resp) => {
          const newList = dataList.concat(resp.data.results);
          setDataList(newList)
          setBOffset(bOffset + 15)
          if(resp.data.results.length === 0){
            setNoData(true)
          } else {
            setNoData(false)
          }
        }).catch((err) => {
          console.log(err);
        }).finally(() => {
          setListLoading(false)
        })
    }, 500)
  }

  const loadCategoryBoundaryLayer = () => {
    setListLoading(true)
    setTimeout(() => {
      buildingCRUD.loadBuildingDashboard(15, bOffset, dataCategory, serchValue).then((resp) => {
          const newList = dataList.concat(resp.data.results);
          setDataList(newList)
          setBOffset(bOffset + 15)
          if(resp.data.results.length === 0){
            setNoData(true)
          } else {
            setNoData(false)
          }
        }).catch((err) => {
          console.log(err);
        }).finally(() => {
          setListLoading(false)
        })
    }, 500)
  }


  useEffect(() => {
    if(value == 6){
      if(category === null){
        setBOffset(0)
        setDataList([])
        setTimeout(() => {
          loadBuildingLayer()
        },500)
      } else {
        setBOffset(0)
        setDataList([])
        setTimeout(() => {
          loadCategoryBoundaryLayer()
        },500)
      }
    } else if(dataValue !== null) {
      setZOffset(0)
      setDataList([])
      setTimeout(() => {
        loadBoundaryLayer()
      },500)
    }
  },[value, dataValue, serchValue, category])


  const handleScroll = () => {
    if (listInnerRef.current) {
      if(value == 6){
        if(category === null){
          const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
          if( scrollTop + clientHeight + 1 >= scrollHeight) {
            if(noData === false){
              loadBuildingLayer()
            }
          }
        } else {
          const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
          if( scrollTop + clientHeight + 1 >= scrollHeight) {
            if(noData === false){
              loadCategoryBoundaryLayer()
            }
          }
        }
      } else {
        const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
        if( scrollTop + clientHeight + 1 >= scrollHeight) {
          if(noData === false){
            loadBoundaryLayer()
          }
        }
      }
    }
  }



  const toggleActive = i => {
    setIsActive(i)
  };

  const handleCheck = (e) => {
    setListValue(e)
  }

  const handleSearch = (event) => {
    setSearchValue(event.target.value)
  }

  const handleAllPolygon = (e) => {

    setIsActive(null)
    setListValue(null)

    setZOffset(0)
    setBOffset(0)
    setDataList([])

    // Reset cascading filters
    setSelectedIsland('')
    setSelectedRegion('')
    setSelectedDistrict('')
    setSelectedShehia('')
    setSelectedZone('')
    if (setBoundaryFilter) setBoundaryFilter(null)

    setValue(e.target.value)

    if(e.target.value === 1 || e.target.value === '1') {
      setDatValue('Island')
      setTypeData('boundary')
    } else if(e.target.value === 2 || e.target.value === '2') {
      setDatValue('Region')
      setTypeData('boundary')
    } else if(e.target.value === 3 || e.target.value === '3') {
      setDatValue('District')
      setTypeData('boundary')
    } else if(e.target.value === 4 || e.target.value === '4') {
      setDatValue('Locality')
      setTypeData('boundary')
    } else if(e.target.value === 5 || e.target.value === '5') {
      setDatValue('Zone')
      setTypeData('boundary')
    } else if(e.target.value === 6 || e.target.value === '6') {
      setDatValue('Building')
      setTypeData('building')
    }

  }

  const handleCategory = (e) => {
    setIsActive(null)

    setListValue(null)

    setZOffset(0)
    setBOffset(0)
    setDataList([])
    if(e.target.value === 25 || e.target.value === '25') {
      setCategory(e.target.value)
      setDataCategory('Residential')
    } else if(e.target.value === 26 || e.target.value === '26') {
      setCategory(e.target.value)
      setDataCategory('Commercial')
    } else if(e.target.value === 27 || e.target.value === '27') {
      setCategory(e.target.value)
      setDataCategory('Civic')
    } else if(e.target.value === 28 || e.target.value === '28') {
      setCategory(e.target.value)
      setDataCategory('Religious')
    } else if(e.target.value === 29 || e.target.value === '29') {
      setCategory(e.target.value)
      setDataCategory('Mixed')
    } else {
      setCategory(null)
      setDataCategory('')
    }
  }


  const dropdownStyle = {marginLeft: '0.7vh', marginRight: '0.7vh', marginTop: '2px'}

  let boundaryData = null

  if(dataValue !== null) {
    boundaryData = (
      <div>
        <div style={{
          fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase',
          letterSpacing: 0.6, marginBottom: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'baseline',
        }}>
          <span>Results</span>
          {dataList && dataList.length > 0 && (
            <span style={{ fontSize: 10.5, color: '#94a3b8', textTransform: 'none', letterSpacing: 0 }}>
              {dataList.length} loaded
            </span>
          )}
        </div>
        <div
          onScroll={handleScroll}
          ref={listInnerRef}
          className="tableFixHeadMap"
          style={{
            border: '1px solid #e2e8f0', borderRadius: 8, background: '#fff',
            overflow: 'auto', maxHeight: 'calc(100vh - 340px)',
          }}
        >
          {dataList?.map((dt, i) => {
            const isSelected = isActive === i;
            return (
              <div
                key={i}
                onClick={() => { handleCheck(dt.id); toggleActive(i); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10,
                  padding: '9px 12px', cursor: 'pointer',
                  borderBottom: '1px solid #f1f5f9',
                  background: isSelected ? '#ecfeff' : '#fff',
                  transition: 'background 0.12s',
                }}
                onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.background = '#f8fafc'; }}
                onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.background = '#fff'; }}
              >
                <span style={{
                  width: 16, height: 16, borderRadius: '50%',
                  border: isSelected ? '5px solid #0891b2' : '2px solid #cbd5e1',
                  background: '#fff', flexShrink: 0, transition: 'all 0.15s',
                }}></span>
                <span style={{
                  fontSize: 12.5, color: isSelected ? '#0c4a6e' : '#334155',
                  fontWeight: isSelected ? 600 : 500, wordBreak: 'break-word',
                }}>
                  {value == 6 ? dt.brn : dt.boundary_name}
                </span>
              </div>
            );
          })}
          {noData === false && listLoading && (
            <div style={{ padding: '14px 12px', textAlign: 'center' }}>
              <div className="bubble"></div>
              <div className="bubble"></div>
              <div className="bubble"></div>
              <div className="bubble"></div>
            </div>
          )}
          {noData === true && (
            <div style={{ padding: '14px 12px', textAlign: 'center', fontSize: 11.5, color: '#94a3b8', fontStyle: 'italic' }}>
              — end of results —
            </div>
          )}
          {(!dataList || dataList.length === 0) && !listLoading && !noData && (
            <div style={{ padding: '14px 12px', textAlign: 'center', fontSize: 12, color: '#94a3b8' }}>
              No data yet
            </div>
          )}
        </div>
      </div>
    )
  }


  return (
    <>
      <div style={{ padding: '14px 12px', fontFamily: "'Segoe UI', Roboto, Arial, sans-serif" }}>
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          marginBottom: 16, paddingBottom: 12, borderBottom: '1px solid #e2e8f0',
        }}>
          <Link to={'/dashboard'} style={{ textDecoration: 'none' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{
                width: 32, height: 32, borderRadius: 8,
                background: 'linear-gradient(135deg, #0c4a6e 0%, #0891b2 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#fff', fontSize: 14,
              }}>
                <i className="bi bi-map-fill"></i>
              </div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#0c4a6e', letterSpacing: 0.3, lineHeight: 1 }}>
                  SHEHIA
                </div>
                <div style={{ fontSize: 11, fontWeight: 600, color: '#64748b', letterSpacing: 1, lineHeight: 1.2 }}>
                  REGISTER
                </div>
              </div>
            </div>
          </Link>
          <button
            onClick={(e) => { e.preventDefault(); navigate(-1); }}
            style={{
              background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 6,
              padding: '5px 10px', fontSize: 11.5, color: '#475569', cursor: 'pointer',
              display: 'inline-flex', alignItems: 'center', gap: 4, fontWeight: 500,
            }}
            title="Go back"
          >
            <i className="bi bi-chevron-left" style={{ fontSize: 10 }}></i> Back
          </button>
        </div>

        {/* Primary layer select */}
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 5, display: 'block' }}>
            Primary layer
          </label>
          <select
            className="form-select form-select-sm"
            onChange={handleAllPolygon}
            value={value}
            style={{ fontSize: 13, borderColor: '#cbd5e1' }}
          >
            <option hidden>Select a layer to view</option>
            <option value="1">🏝 Island</option>
            <option value="2">🗺 Region</option>
            <option value="3">📍 District</option>
            <option value="4">🏘 Shehia</option>
            <option value="5">🔖 Zone</option>
            <option value="6">🏠 Building</option>
          </select>
        </div>

      {/* Cascading boundary filters when Building is selected */}
      {value == 6 && (
        <div style={{
          background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8,
          padding: 10, marginBottom: 12,
        }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 8 }}>
            Filter buildings
          </div>
          <select className="form-select form-select-sm mb-2" onChange={handleCategory} value={category || ''} style={{ fontSize: 12.5 }}>
            <option value="">All categories</option>
            <option value={25}>🏠 Residential</option>
            <option value={26}>🏢 Commercial</option>
            <option value={27}>🏛 Civic</option>
            <option value={28}>⛪ Religious</option>
            <option value={29}>🏗 Mixed use</option>
          </select>

          <select className="form-select form-select-sm mb-2"
            value={selectedIsland} onChange={(e) => setSelectedIsland(e.target.value)}
            style={{ fontSize: 12.5 }}
          >
            <option value="">All islands</option>
            {islands.map((isl) => (
              <option key={isl.id} value={isl.id}>{isl.name}</option>
            ))}
          </select>

          {selectedIsland && regions.length > 0 && (
            <select className="form-select form-select-sm mb-2"
              value={selectedRegion} onChange={(e) => setSelectedRegion(e.target.value)}
              style={{ fontSize: 12.5 }}
            >
              <option value="">All regions</option>
              {regions.map((r) => (
                <option key={r.id} value={r.id}>{r.boundary_name}</option>
              ))}
            </select>
          )}

          {selectedRegion && districts.length > 0 && (
            <select className="form-select form-select-sm mb-2"
              value={selectedDistrict} onChange={(e) => setSelectedDistrict(e.target.value)}
              style={{ fontSize: 12.5 }}
            >
              <option value="">All districts</option>
              {districts.map((d) => (
                <option key={d.id} value={d.id}>{d.boundary_name}</option>
              ))}
            </select>
          )}

          {selectedDistrict && shehias.length > 0 && (
            <select className="form-select form-select-sm mb-2"
              value={selectedShehia} onChange={(e) => setSelectedShehia(e.target.value)}
              style={{ fontSize: 12.5 }}
            >
              <option value="">All shehias</option>
              {shehias.map((s) => (
                <option key={s.id} value={s.id}>{s.boundary_name}</option>
              ))}
            </select>
          )}

          {selectedShehia && zones.length > 0 && (
            <select className="form-select form-select-sm"
              value={selectedZone} onChange={(e) => setSelectedZone(e.target.value)}
              style={{ fontSize: 12.5 }}
            >
              <option value="">All zones</option>
              {zones.map((z) => (
                <option key={z.id} value={z.id}>{z.boundary_name}</option>
              ))}
            </select>
          )}
        </div>
      )}

      {/* Search */}
      <div style={{ position: 'relative', marginBottom: 12 }}>
        <i className="ri-search-line" style={{
          position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
          color: '#94a3b8', fontSize: 14, pointerEvents: 'none',
        }}></i>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Search by name…"
          value={serchValue}
          onChange={handleSearch}
          style={{
            paddingLeft: 32, fontSize: 12.5, borderColor: '#cbd5e1',
            height: 34,
          }}
        />
      </div>

      {boundaryData}
      </div>
    </>
  )

}
